import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Box, HStack, IconButton, Image, Stack, Text } from "@chakra-ui/react";
import { FiTrash2 } from "react-icons/fi";

const BundleEvent = ({
  isEditingEvents,
  link,
  image,
  name,
  venueName,
  startAt,
  id,
  isDisabled,
  onDelete,
}) => {
  return (
    <Box
      style={{
        userSelect: "none",
        opacity: isDisabled ? 0.5 : 1,
        borderBottom: "1px solid",
        borderBottomColor: "#EDF2F7", // Chakra's gray.100
        paddingTop: "0.5rem",
        paddingBottom: "0.5rem",
      }}
    >
      <HStack justify="space-between" width="100%">
        <HStack
          paddingLeft={!isEditingEvents ? 8 : 0}
          width="calc(100% - 100px)"
        >
          <Box
            w="100px"
            h="100px"
            overflow="hidden"
            justifyContent="center"
            display="flex"
            flexShrink={0}
          >
            <Image
              objectFit="cover"
              rounded="lg"
              height="100%"
              width="100%"
              src={image}
              fallbackSrc="https://content.kydlabs.com/system/plcaeholderimage.png"
            />
          </Box>
          <Stack spacing={0} width="100%">
            <Text
              fontSize="lg"
              fontWeight="medium"
              onClick={() => link && window.open(link)}
              cursor="pointer"
              isTruncated
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {name}
              <ExternalLinkIcon cursor="pointer" w={3} h={3} ml={4} />
            </Text>
            <Text
              fontSize="sm"
              isTruncated
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {venueName}
            </Text>
            <Text
              fontSize="sm"
              isTruncated
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {startAt}
            </Text>
          </Stack>
        </HStack>
        {isEditingEvents && (
          <IconButton
            icon={<FiTrash2 />}
            aria-label="Delete event"
            isDisabled={isDisabled}
            onClick={() => onDelete(id)}
          />
        )}
      </HStack>
    </Box>
  );
};

export default BundleEvent;
